<template>
    <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        xmlns="http://www.w3.org/2000/svg">
        <rect x="9" y="2" width="6" height="12" rx="3" />
        <path d="M18 11a6 6 0 0 1-12 0" />
        <path d="M12 17v4" />
        <path d="M9 21h6" />
    </svg>
</template>
